import React from "react";
import styled from "styled-components";

const TextArea = styled.textarea.attrs(props => ({
  // we can define static props
  rows: props.rows || "4"
}))`
  line-height: 30px;
  font-size: 20px;
  padding-left: 5px;
  width: 100%;
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  border-color: ${props => props.theme.color4};
  margin-top: 5px;
  margin-bottom: 5px;
  ::placeholder {
    color: ${props => props.theme.color4};
  }
`;

export default TextArea;
